import { Button, Grid, makeStyles, Typography } from '@material-ui/core'

import Modal from 'components/ui/Modal'
import moment from 'moment'

import { history } from 'utils'

export interface Props {
  showMTAModal: boolean
  redirect: string
  current: any
  closeMTAModalAction: () => void
}

const useStyles = makeStyles(theme => ({
  firstButton: {
    marginLeft: 'auto',
    marginRight: 10,
  },
  modalText: {
    paddingTop: 0,
    marginTop: 0,
  },
}))

const MTAModal = ({ showMTAModal, redirect, current, closeMTAModalAction }: Props) => {
  const classes = useStyles()
  const startDate = current?.effective
  const showNewMTAIID = moment('20250619', 'YYYYMMDD')
  const now = moment(startDate)
  const MTAIID1 = 'https://assets.ctfassets.net/numinvtctmda/3UPxpmFGri23idP1DixPhP/c203c6f7aff3c3869c11cbf351d07d3b/TYA_Important_Information_v3.pdf'
  const MTAIID2 = 'https://assets.ctfassets.net/numinvtctmda/OZTVO8pZGTLngZ5F9zdqW/fd9b8eb92c895ea6688df8f7033f761e/TYA_Important_Information_v4.pdf'
  
  return (
    <Modal open={showMTAModal} onClose={closeMTAModalAction}>
      <Grid item xs={12}>
        <h1>{`Please note`}</h1>
        <p className={classes.modalText}>
          {'This policy change will incur a fee and could result in an increase in your premium. Please refer to our '}
          <a href={now.isSameOrAfter(showNewMTAIID)? MTAIID2 : MTAIID1} target="_blank" rel="noreferrer">
            {'Important Information document'}
          </a>
          {' for a summary of our charges.'}
        </p>
        <Button
          variant="outlined"
          color="secondary"
          className={classes.firstButton}
          onClick={() => {
            closeMTAModalAction()
          }}
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            closeMTAModalAction()
            history.push(redirect)
          }}
        >
          Continue
        </Button>
      </Grid>
    </Modal>
  )
}

export default MTAModal
